var _rect, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgOptimism(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Optimism",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "Boundary",
    width: 32,
    height: 32,
    rx: 12,
    transform: "translate(0 32) rotate(-90)",
    fill: "transparent"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Profile-Logo",
    transform: "translate(7 7)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_69",
    "data-name": "Ellipse 69",
    cx: 9,
    cy: 9,
    r: 9,
    fill: "#ff0420"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_545",
    "data-name": "Path 545",
    d: "M128.295,186.211a2.163,2.163,0,0,1-1.317-.378,1.293,1.293,0,0,1-.507-1.094,2.435,2.435,0,0,1,.034-.365q.088-.486.25-1.169a2.218,2.218,0,0,1,2.371-1.858,2.357,2.357,0,0,1,.932.176,1.417,1.417,0,0,1,.648.513,1.378,1.378,0,0,1,.236.811,2.4,2.4,0,0,1-.034.358q-.1.6-.243,1.169a2.191,2.191,0,0,1-2.371,1.837Zm.095-.973a.96.96,0,0,0,.642-.223,1.244,1.244,0,0,0,.385-.682q.155-.635.236-1.108a1.55,1.55,0,0,0,.027-.29q0-.615-.642-.615a.986.986,0,0,0-.648.223,1.266,1.266,0,0,0-.378.682q-.122.453-.243,1.108a1.441,1.441,0,0,0-.027.284Q127.741,185.238,128.389,185.238Z",
    transform: "translate(-121.918 -174.819)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_546",
    "data-name": "Path 546",
    d: "M255.582,187.951a.143.143,0,0,1-.115-.047.162.162,0,0,1-.02-.122l.932-4.391a.193.193,0,0,1,.074-.122.206.206,0,0,1,.128-.047h1.8a2.088,2.088,0,0,1,1.2.311,1.018,1.018,0,0,1,.459.9,1.619,1.619,0,0,1-.041.351,1.829,1.829,0,0,1-.682,1.148,2.31,2.31,0,0,1-1.392.372h-.912l-.311,1.479a.193.193,0,0,1-.074.122.206.206,0,0,1-.128.047Zm2.391-2.58a.8.8,0,0,0,.493-.155.73.73,0,0,0,.284-.446,1.183,1.183,0,0,0,.02-.2.375.375,0,0,0-.115-.3.566.566,0,0,0-.392-.108h-.811l-.257,1.209Z",
    transform: "translate(-246.247 -176.627)",
    fill: "#fff"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOptimism);
export default __webpack_public_path__ + "static/media/optimism.ae3bab7f818a0f6ee74f62191aee40ed.svg";
export { ForwardRef as ReactComponent };